// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see PersonalProfileTapUpsellEvent
 */
export var PersonalProfileTapUpsell = function (_a) {
    var url = _a.url, type = _a.type;
    return ({
        name: "PersonalProfile Tap Upsell",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Tap",
            url: url !== undefined && url !== null ? url.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileTapShoppingAutofillAddressEvent
 */
export var PersonalProfileTapShoppingAutofillAddress = function (_a) {
    var autofillEnabled = _a.autofillEnabled;
    return ({
        name: "PersonalProfile Tap ShoppingAutofillAddress",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Tap",
            autofill_enabled: autofillEnabled !== undefined && autofillEnabled !== null ? autofillEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileTapShoppingAutofillToggleEvent
 */
export var PersonalProfileTapShoppingAutofillToggle = function (_a) {
    var autofillEnabled = _a.autofillEnabled, autofillEnabledAttemptedChange = _a.autofillEnabledAttemptedChange;
    return ({
        name: "PersonalProfile Tap ShoppingAutofillToggle",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Tap",
            autofill_enabled: autofillEnabled !== undefined && autofillEnabled !== null ? autofillEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            autofill_enabled_attempted_change: autofillEnabledAttemptedChange !== undefined && autofillEnabledAttemptedChange !== null ? autofillEnabledAttemptedChange.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileEditOpenEvent
 */
export var PersonalProfileEditOpen = function (_a) {
    var screen = _a.screen, isBusinessProfile = _a.isBusinessProfile;
    return ({
        name: "PersonalProfile Edit Open",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Edit",
            screen: screen !== undefined && screen !== null ? screen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_business_profile: isBusinessProfile !== undefined && isBusinessProfile !== null ? isBusinessProfile.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileEditUpdateBusinessNameEvent
 */
export var PersonalProfileEditUpdateBusinessName = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "PersonalProfile Edit UpdateBusinessName",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Edit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileEditUpdateCashtagEvent
 */
export var PersonalProfileEditUpdateCashtag = function (_a) {
    var flowToken = _a.flowToken, isBusinessProfile = _a.isBusinessProfile;
    return ({
        name: "PersonalProfile Edit UpdateCashtag",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Edit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_business_profile: isBusinessProfile !== undefined && isBusinessProfile !== null ? isBusinessProfile.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileEditUpdateBioEvent
 */
export var PersonalProfileEditUpdateBio = function (_a) {
    var flowToken = _a.flowToken, isBusinessProfile = _a.isBusinessProfile;
    return ({
        name: "PersonalProfile Edit UpdateBio",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Edit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_business_profile: isBusinessProfile !== undefined && isBusinessProfile !== null ? isBusinessProfile.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileEditUpdateProfileColorEvent
 */
export var PersonalProfileEditUpdateProfileColor = function (_a) {
    var color = _a.color, isBusinessProfile = _a.isBusinessProfile;
    return ({
        name: "PersonalProfile Edit UpdateProfileColor",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Edit",
            color: color !== undefined && color !== null ? color.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_business_profile: isBusinessProfile !== undefined && isBusinessProfile !== null ? isBusinessProfile.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileEditUpdateLocationEvent
 */
export var PersonalProfileEditUpdateLocation = function (_a) {
    var flowToken = _a.flowToken, isBusinessProfile = _a.isBusinessProfile;
    return ({
        name: "PersonalProfile Edit UpdateLocation",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Edit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_business_profile: isBusinessProfile !== undefined && isBusinessProfile !== null ? isBusinessProfile.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileEditUpdateBusinessCategoryEvent
 */
export var PersonalProfileEditUpdateBusinessCategory = function (_a) {
    var flowToken = _a.flowToken;
    return ({
        name: "PersonalProfile Edit UpdateBusinessCategory",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Edit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileEditLinkSocialAccountEvent
 */
export var PersonalProfileEditLinkSocialAccount = function (_a) {
    var flowToken = _a.flowToken, isBusinessProfile = _a.isBusinessProfile, accountsType = _a.accountsType;
    return ({
        name: "PersonalProfile Edit LinkSocialAccount",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Edit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_business_profile: isBusinessProfile !== undefined && isBusinessProfile !== null ? isBusinessProfile.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            accounts_type: accountsType !== undefined && accountsType !== null ? accountsType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileEditUnlinkSocialAccountEvent
 */
export var PersonalProfileEditUnlinkSocialAccount = function (_a) {
    var flowToken = _a.flowToken, isBusinessProfile = _a.isBusinessProfile, accountsType = _a.accountsType;
    return ({
        name: "PersonalProfile Edit UnlinkSocialAccount",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Edit",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_business_profile: isBusinessProfile !== undefined && isBusinessProfile !== null ? isBusinessProfile.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            accounts_type: accountsType !== undefined && accountsType !== null ? accountsType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileViewOpenEvent
 */
export var PersonalProfileViewOpen = function (_a) {
    var screen = _a.screen, isBusinessProfile = _a.isBusinessProfile;
    return ({
        name: "PersonalProfile View Open",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "View",
            screen: screen !== undefined && screen !== null ? screen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_business_profile: isBusinessProfile !== undefined && isBusinessProfile !== null ? isBusinessProfile.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileViewOpenScreenEvent
 */
export var PersonalProfileViewOpenScreen = function (_a) {
    var screen = _a.screen, entryPoint = _a.entryPoint;
    return ({
        name: "PersonalProfile View OpenScreen",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "View",
            screen: screen !== undefined && screen !== null ? screen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileViewOpenStatementSummaryEvent
 */
export var PersonalProfileViewOpenStatementSummary = function (_a) {
    var month = _a.month;
    return ({
        name: "PersonalProfile View OpenStatementSummary",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "View",
            month: month !== undefined && month !== null ? month.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileViewOpenStatementDetailEvent
 */
export var PersonalProfileViewOpenStatementDetail = function (_a) {
    var month = _a.month, category = _a.category;
    return ({
        name: "PersonalProfile View OpenStatementDetail",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "View",
            month: month !== undefined && month !== null ? month.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            category: category !== undefined && category !== null ? category.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileViewOpenStatementFileEvent
 */
export var PersonalProfileViewOpenStatementFile = function (_a) {
    var month = _a.month, entryPoint = _a.entryPoint, shareOption = _a.shareOption;
    return ({
        name: "PersonalProfile View OpenStatementFile",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "View",
            month: month !== undefined && month !== null ? month.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            share_option: shareOption !== undefined && shareOption !== null ? shareOption.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileViewOpenAccountStatementsEvent
 */
export var PersonalProfileViewOpenAccountStatements = function () { return ({
    name: "PersonalProfile View OpenAccountStatements",
    parameters: {
        cdf_entity: "PersonalProfile",
        cdf_action: "View",
    }
}); };
/**
 * @see PersonalProfileViewOpenLinkEvent
 */
export var PersonalProfileViewOpenLink = function (_a) {
    var destination = _a.destination;
    return ({
        name: "PersonalProfile View OpenLink",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "View",
            destination: destination !== undefined && destination !== null ? destination.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileViewShareEvent
 */
export var PersonalProfileViewShare = function (_a) {
    var isBusinessProfile = _a.isBusinessProfile;
    return ({
        name: "PersonalProfile View Share",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "View",
            is_business_profile: isBusinessProfile !== undefined && isBusinessProfile !== null ? isBusinessProfile.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileViewOpenAddFavoritesEvent
 */
export var PersonalProfileViewOpenAddFavorites = function (_a) {
    var favoritesCount = _a.favoritesCount;
    return ({
        name: "PersonalProfile View OpenAddFavorites",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "View",
            favorites_count: favoritesCount !== undefined && favoritesCount !== null ? favoritesCount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileViewUpsellImpressionEvent
 */
export var PersonalProfileViewUpsellImpression = function (_a) {
    var type = _a.type;
    return ({
        name: "PersonalProfile View UpsellImpression",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "View",
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileViewShoppingAutofillSettingsEvent
 */
export var PersonalProfileViewShoppingAutofillSettings = function (_a) {
    var autofillEnabled = _a.autofillEnabled;
    return ({
        name: "PersonalProfile View ShoppingAutofillSettings",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "View",
            autofill_enabled: autofillEnabled !== undefined && autofillEnabled !== null ? autofillEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileViewShoppingAutofillToggleErrorEvent
 */
export var PersonalProfileViewShoppingAutofillToggleError = function (_a) {
    var autofillEnabled = _a.autofillEnabled, autofillEnabledAttemptedChange = _a.autofillEnabledAttemptedChange;
    return ({
        name: "PersonalProfile View ShoppingAutofillToggleError",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "View",
            autofill_enabled: autofillEnabled !== undefined && autofillEnabled !== null ? autofillEnabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            autofill_enabled_attempted_change: autofillEnabledAttemptedChange !== undefined && autofillEnabledAttemptedChange !== null ? autofillEnabledAttemptedChange.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileManageAddPhotoEvent
 */
export var PersonalProfileManageAddPhoto = function (_a) {
    var screen = _a.screen, isBusinessProfile = _a.isBusinessProfile;
    return ({
        name: "PersonalProfile Manage AddPhoto",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Manage",
            screen: screen !== undefined && screen !== null ? screen.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            is_business_profile: isBusinessProfile !== undefined && isBusinessProfile !== null ? isBusinessProfile.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileManageAddFavoriteEvent
 */
export var PersonalProfileManageAddFavorite = function () { return ({
    name: "PersonalProfile Manage AddFavorite",
    parameters: {
        cdf_entity: "PersonalProfile",
        cdf_action: "Manage",
    }
}); };
/**
 * @see PersonalProfileManageUpgradeToBusinessEvent
 */
export var PersonalProfileManageUpgradeToBusiness = function (_a) {
    var entryPoint = _a.entryPoint, businessUpgradeFlowToken = _a.businessUpgradeFlowToken;
    return ({
        name: "PersonalProfile Manage UpgradeToBusiness",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Manage",
            entry_point: entryPoint !== undefined && entryPoint !== null ? entryPoint.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            business_upgrade_flow_token: businessUpgradeFlowToken !== undefined && businessUpgradeFlowToken !== null ? businessUpgradeFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileManageUpgradeToBusinessSubmitEvent
 */
export var PersonalProfileManageUpgradeToBusinessSubmit = function (_a) {
    var businessUpgradeFlowToken = _a.businessUpgradeFlowToken;
    return ({
        name: "PersonalProfile Manage UpgradeToBusinessSubmit",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Manage",
            business_upgrade_flow_token: businessUpgradeFlowToken !== undefined && businessUpgradeFlowToken !== null ? businessUpgradeFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileManageUpgradeToBusinessCancelledEvent
 */
export var PersonalProfileManageUpgradeToBusinessCancelled = function (_a) {
    var businessUpgradeFlowToken = _a.businessUpgradeFlowToken;
    return ({
        name: "PersonalProfile Manage UpgradeToBusinessCancelled",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Manage",
            business_upgrade_flow_token: businessUpgradeFlowToken !== undefined && businessUpgradeFlowToken !== null ? businessUpgradeFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileManageUpgradeToBusinessSucceededEvent
 */
export var PersonalProfileManageUpgradeToBusinessSucceeded = function (_a) {
    var businessUpgradeFlowToken = _a.businessUpgradeFlowToken;
    return ({
        name: "PersonalProfile Manage UpgradeToBusinessSucceeded",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Manage",
            business_upgrade_flow_token: businessUpgradeFlowToken !== undefined && businessUpgradeFlowToken !== null ? businessUpgradeFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileManageUpgradeToBusinessFailedEvent
 */
export var PersonalProfileManageUpgradeToBusinessFailed = function (_a) {
    var businessUpgradeFlowToken = _a.businessUpgradeFlowToken;
    return ({
        name: "PersonalProfile Manage UpgradeToBusinessFailed",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Manage",
            business_upgrade_flow_token: businessUpgradeFlowToken !== undefined && businessUpgradeFlowToken !== null ? businessUpgradeFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileManageAddAccountEvent
 */
export var PersonalProfileManageAddAccount = function (_a) {
    var flowToken = _a.flowToken, accountType = _a.accountType;
    return ({
        name: "PersonalProfile Manage AddAccount",
        parameters: {
            cdf_entity: "PersonalProfile",
            cdf_action: "Manage",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            account_type: accountType !== undefined && accountType !== null ? accountType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see PersonalProfileSignOutConfirmEvent
 */
export var PersonalProfileSignOutConfirm = function () { return ({
    name: "PersonalProfile SignOut Confirm",
    parameters: {
        cdf_entity: "PersonalProfile",
        cdf_action: "SignOut",
    }
}); };
